import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useProjectContext } from '../context/ProjectContext';

import Loader from '../components/Loader';
// import NotFound from '../pages/NotFound';

import ExportPdfCapeb from './capeb/ExportPdfCapeb';

const ExportPdf = () => {
  const { project, loading, setProjectSlug } = useProjectContext();
  const { slug } = useParams('');
  
  // Load project info if slug change
  useEffect(() => {
    setProjectSlug(slug);
  }, [slug]);
  
  
  // Switch content
  const switchExportPdf = (project) => {
    switch(project.slug) {
      case 'capeb':
        return (<ExportPdfCapeb project={project} />);
      default:
        return (<h1>{ project.name }</h1>);
    }
  };
  
  // Render main content
  const renderContent = () => {
    if (loading) {
      return (<Loader />);
    }
    
    if (!project) {
      // return (<NotFound type="project" />);
      return '';
    }
    
    return (
      <div className="ra-exportpdf__content">
        {switchExportPdf(project)}
      </div>  
    );
  };
  
  return (
    <div className={`ra-exportpdf ${loading ? 'ra-exportpdf--loading' : ''} ${project ? 'ra-exportpdf--' + project.slug : ''}`}>
      {renderContent()}
    </div>
  );
};

export default ExportPdf;